import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Services/StoreConfig";
import { ThemeProvider, Toaster } from "@geti/identidade-visual-react";
import { PermissionProvider } from "./Auth/PermissionContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <PermissionProvider>
        <App />
        <Toaster position="top-right" richColors closeButton />
      </PermissionProvider>
    </ThemeProvider>
  </Provider>
);
